import React from "react";
import ButtonIcon from "../../../../components/atoms/button/buttonIcon";
import {IconSource} from "../../../../shared/enums/iconSource";
import CsvDownloader from "react-csv-downloader";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../stores/useStores";
import {ToastMessageStatus} from "../../../../components/atoms/toastMessage/toastMessage";
import {format} from "date-fns";

const MetricsCsvWrapper: React.FC = () => {
  const {
    domainStore: {
      metricsDomainStore: {
        canExport,
        searchParams,
        metricsColumns,
        computedMetrics,
        selectedTab
      }
    },
    uiStore: {toastMessageStore}
  } = useStores();

  const formatDate = (date?: Date) => {
    if (date) return format(date, "dd-MM-yyyy");

    return "-";
  };

  const formatCsvTitle = () => {
    if (!searchParams) return "";

    const startDate = formatDate(searchParams.startDate);
    const endDate = formatDate(searchParams.endDate);
    const calendarType = searchParams.selectedCalendarType;

    return (
      `Metrics_${selectedTab}_${startDate}_${endDate}` +
      (calendarType ? `_${calendarType}` : "")
    );
  };

  const getCsvColumns = () => {
    return metricsColumns.map((column) => {
      return {id: column.dataField, displayName: column.headerLabel};
    });
  };

  const formatCsvData = () => {
    const records: any[] = [];
    computedMetrics
      .filter((m) => !m.isTotalsRow)
      .forEach((metric) => {
        const record: any = {};
        metricsColumns.forEach((column) => {
          record[column.dataField] = column.rawValue(metric);
        });
        records.push(record);
      });
    return records;
  };

  const onError = () => {
    toastMessageStore.displayToastMessage(
      "Failed to download metrics. Please try again.",
      ToastMessageStatus.Danger
    );
  };

  return (
    <CsvDownloader
      datas={formatCsvData()}
      filename={formatCsvTitle()}
      extension={".csv"}
      wrapColumnChar={'"'}
      columns={getCsvColumns()}
      onError={onError}
    >
      <ButtonIcon
        type={"secondary"}
        icon={IconSource.export}
        isDisabled={!canExport}
        testId={"export-metrics-button"}
      >
        Export
      </ButtonIcon>
    </CsvDownloader>
  );
};

export default observer(MetricsCsvWrapper);
